import { jsx } from '@emotion/react';
import { Fragment } from 'react';
import { LegacyButton } from '@zapier/design-system';
import { emitUserInteractionEvent } from '../../utils/avroEvents';
import { labelStyles } from '@zapier/style-encapsulation';
import { loginPath, signupPath } from '../../constants';
import { useUniversalNavContext } from '../../hooks';
import InAppTopbarLink from './InAppTopbar/InAppTopbarLink';
const Styles = labelStyles('AccountActions', {
    signupButton: {
        minWidth: 100,
    },
});
export const AccountActions = ({ shouldRenderSignIn, shouldRenderSignUp, loginHref = loginPath, signupHref = signupPath, }) => {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const signupPreintentEvent = () => {
        emitUserInteractionEvent({
            interaction_name: 'universalnav-signup',
            event_action: 'click',
            option_selected: 'Sign up',
        });
    };
    return (jsx(Fragment, null,
        shouldRenderSignIn && (jsx(InAppTopbarLink, { navigationItem: {
                variant: 'link',
                href: getFullyQualifiedURL(loginHref) || '',
                text: 'Log in',
            }, position: "actions-menu" }, "Log in")),
        shouldRenderSignUp && (jsx("div", { css: Styles.signupButton, "data-zds": true },
            jsx(LegacyButton, { href: signupHref, id: "universalnav-signup", isFullWidth: true, onClick: signupPreintentEvent, color: "brand" }, "Sign up")))));
};
export default AccountActions;
//# sourceMappingURL=AccountActions.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
